<template>
  <div class="page">
    <div class="container-fluid pt-2 contenu-page">
      <div class="container bg-verifavis p-3">
        <div>
          <h1 class="titre-bienvenue bleu">
          Bienvenue sur le service de vérification des avis
          </h1>
          <br /> 
        <br /> 
        <h4 class="bleu">Vérification de conformité</h4>
        <br />
          <br /> 
          <div class="d-flex justify-content-center align-items-center">
            ERREUR technique
          </div>
        </div>
        <div class="d-flex justify-content-end align-items-center">
          <div class="p-3">
            <button class="btn btn-retour me-2" type="button" @click="$router.back()">Retour à l'étape précédente</button>
            </div>
          </div>
      </div>
    </div>
    <div class="bas-page">© Ministère de l'Économie, des Finances et de la Souveraineté industrielle et numérique</div>
  </div>
</template>

<script>
/**
 * Page d'erreur si API indisponible
 * 
 * @author <span><span class="fw-bold">Inconnu</span><a class="ms-2" href="mailto:inconnu@dgfip.finances.gouv.fr">inconnu@dgfip.finances.gouv.fr</a></span>
 * @since <span class="fw-bold">Version 1.0</span>
 * @displayName Erreur
 */
export default {
  name: "Erreur"
};
</script>
<style>
.bg-verifavis{
  border-style: solid;
  border-color: #5D90C7;
}
.titre-bienvenue{
  width: 100%;
  margin-bottom: 1.25rem;
  font-weight: 700;
}
.bleu{
  color: #5D90C7;
}
.btn-retour {
  background-color: #FFFFFF;
  color: #5D90C7;
  border-bottom-color: #bdbbbb;
  border-right-color: #bdbbbb;
  border-top-color: #FFFFFF;
  border-left-color: #FFFFFF;
  border-width: 0.15rem;
}
.page{
  width: 100%;
  height: 100%;
  min-height: inherit;
  display: flex;
  flex-direction: column;
}
.contenu-page {
  margin: auto;
}
.bas-page {
  border-top: 1px solid #9e9e9e;
  font-size: 80%;
  color: #9e9e9e;
  text-align: center;
  width: 100%;
}
</style>
